import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';

export class Country {
  displayName: string;
  states: State[];
  value: number;
  label?: string;
}

export class State {
  displayName: string;
  value: number;
  label?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  globalUrl: string;

  private countries: Country[];

  constructor(private configService: ConfigService, private httpClient: HttpClient) { }

  getCountriesWithStates(): Observable<Country[]> {
    this.globalUrl = this.configService.getConfiguration().apiUrlData.global;

    if (this.countries) {
      return of(this.countries);

    } else {
      return this.httpClient.get(this.globalUrl + 'postalhelper/').pipe(
        map((response: {countries: Country[]}) => {

          // Add label property for primeng dropdowns
          const countries =  response.countries.map(country => {
            country.label = country.displayName;

            country.states = country.states.map(state => {
              state.label = state.displayName;
              return state;
            });

            return country;
          });

          this.countries = countries;

          return countries;
      }));
    }
  }
}
